import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  class: "UnsafeExitModal"
}
const _hoisted_2 = { class: "UnsafeExitContentBlock" }
const _hoisted_3 = {
  key: 0,
  ref: "loadingButton",
  "data-style": "zoom-in",
  class: "ChampionButton UnsafeExitButton"
}
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "UnsafeExitHeaderBlock" }, [
      _createElementVNode("h3", null, "Save before you go?")
    ], -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "UnsafeExitTextBlock" }, " There are updates to the data that are not saved. Do you want to save before you go to another page? ", -1 /* CACHED */)),
      (_ctx.saveInProgress)
        ? (_openBlock(), _createElementBlock("button", _hoisted_3, null, 512 /* NEED_PATCH */))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "ChampionButton UnsafeExitButton",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveAndNavigate && _ctx.saveAndNavigate(...args))),
            disabled: !_ctx.isSaveEnabled
          }, " Save Changes ", 8 /* PROPS */, _hoisted_4)),
      _createElementVNode("button", {
        class: "NavigatorButton UnsafeExitButton",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.revertAndNavigate && _ctx.revertAndNavigate(...args)))
      }, " Discard and move on ")
    ])
  ], 512 /* NEED_PATCH */))
}